var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"550px","display":"block"},attrs:{"id":("adobe-dc-view-" + (_vm.generateIdentifier()))}})}
var staticRenderFns = []

export { render, staticRenderFns }